import { useMutation, useQuery } from '@apollo/client';
import { AccountClient, MockTicketClient } from '@nile/graphql';
import UserForm from '@nile/banyan/src/Pages/Protected/Configuration/UserForm';
import { UPDATE_CLIENT_USER } from '@nile/graphql/src/Mutation/client';
import {
  GET_CLIENT_USER,
  GET_CLIENT_USERS
} from '@nile/graphql/src/Query/client';
import { Loader, toast, useUserMSPCheckHook } from '@nile/components';
import { cloneDeep } from 'lodash';
import React, { useCallback, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { useFlags } from 'launchdarkly-react-client-sdk';

function EditUser(props) {
  const flags = useFlags();
  const {
    data: user,
    loading: employeeLoading,
    error: employeeError
  } = useQuery(GET_CLIENT_USER, {
    variables: {
      userId: props.id,
      userCustomFields: true
    },
    client: AccountClient,
    fetchPolicy: 'network-only'
  });
  const context = useContext(TicketContext);
  const [updateUser, { loading, error }] = useMutation(UPDATE_CLIENT_USER, {
    client: AccountClient,
    onCompleted({ updateClientUser }) {
      if (updateClientUser) {
        toast('success', 'User updated successfully');
        if (props.actions.refreshTable) {
          props.actions.refreshTable();
        }
        if (props.actions.callback) {
          props.actions.callback(updateClientUser);
        }
      }
      if (props.actions?.back) {
        props.actions.back();
      } else {
        back();
      }
    },
    onError() {
      // toast('error', 'Something went wrong');
    }
  });

  const back = useCallback(() => {
    context.closeTab();
  }, []); // eslint-disable-line

  const switchToEdit = useCallback((data, type) => {
    if (!props.actions.back) {
      back();
    }
    props.actions.switchMode(data, type);
  }, []);

  const actions = {
    primaryAction: updateUser,
    back: back,
    switchToEdit: switchToEdit,
    actionType: props.type,
    ...props.actions
  };

  const isMSP = useUserMSPCheckHook();

  if (employeeLoading) return <Loader />;
  if (employeeError) return <div>error</div>;

  return (
    <UserForm
      actions={actions}
      user={user.getClientUser}
      accountId={props.accountId}
      newLayout={props.newLayout}
      isMSP={isMSP}
    />
  );
}

export default withRouter(EditUser);
